<script context="module">
  let journalName = ''
  let status = ''
  let all = true
</script>

<script>
  import { onMount } from "svelte";
  import { getParsedIssues, getPeriodicals } from './logic'
  import Link from './Link.svelte'
  import { logged } from "./stores";

  // export let pg
  export let issue
 
  let data
  let error
  let periodicals

  const xlate = {
    "downloaded" : 'Staženo',
    "proheadings" : 'Rozpracované nadpisy',
    "headings" : 'Označeny nadpisy',
    "genblocks" : 'Generování bloků',
    "blocks" : 'Připraveno pro čištění',
    "cleaning" : 'Rozpracované čištění',
    "cleaned" : 'Očištěné bloky',
    "genarticles" : 'Generování článků',
    "articles" : 'Připravno pro kontrolu',
    "checking" : 'Rozpracovaná kontrola',
    "checked" : 'Schválená kontrola',
    "exclude" : 'Vyřazeno',
  }
  //console.log('array', Object.entries(xlate), Object.keys(xlate), Object.values(xlate))
  //console.log('array2', Object.keys(xlate).map(x => {const y = {}; y[x]=xlate[x]; return y})))
  const array = Object.keys(xlate).map(x => {const y = {key:x, val:xlate[x]}; return y})

  onMount(async () => {
    await search()
    {({error, periodicals} = await getPeriodicals())}
  })

  const search = async () => {
    console.log('search')
    if (all) {
      {({error, data} = await getParsedIssues(journalName, status))}
    } else {
      {({error, data} = await getParsedIssues(journalName, status, $logged))}
    }
  }
</script>
<!-- {JSON.stringify(periodicals)} -->
<!-- {journalName} {status} {all} -->

<div class="grid grid-cols-[1fr_1fr_auto] gap-4 w-3/4">
  <label class="label" for="periodicals">
    <span class="mr-2">Periodikum</span>
    {#if periodicals}
    <select class="select" id="periodicals" bind:value={journalName} on:change={search}>
      <option value=""></option>
      {#each periodicals as {item}}
        <option value={item}>{item}</option>
      {/each}
    </select>
    {/if}
  </label>
  
  <label class="label">
    <span class="mr-2">Stav</span>
    <select class="select" bind:value={status} on:change={search}>
      <option value=""></option>
      {#each array as {key, val}}
        <option value="{key}">{val}</option>
      {/each}
    </select>
  </label>
  
  <div class="pt-5 self-center">
    {#if all}
      všechny / <a class="anchor" href="/" on:click|preventDefault={() => {all = !all; search()}}>moje</a>
    {:else}
      <a class="anchor" href="/" on:click|preventDefault={() => {all = !all; search()}}>všechny</a> / moje
    {/if}
  </div>
</div>
{#if error}<div class="error">{error}</div>{/if}
<!-- {JSON.stringify(data)} -->

{#if data}
<div class="table-container mt-4">
  <table class="table table-compact">
    <thead class="text-left">
      <th>Akce</th>
      <th class="min-w-[15em]">Jméno periodika</th>
      <th>Ročník</th>
      <th>Číslo</th>
      <th>Datum vydání</th>
      <th>Stav</th>
      <th>Kdo</th>
      <th>Kdy</th>
    </thead>
    <tbody>
      {#each data as line}
        <tr>
          <td>
            <!-- <Link to="heading" {line} bind:issue>*</Link>
            <Link to="clean" {line} bind:issue>*</Link>
            <Link to="check" {line} bind:issue>*</Link> -->
            {#if line.state === 'downloaded' || line.state === 'proheadings' || line.state === 'headings' || line.state === 'exclude' }
              <Link to="heading" {line} bind:issue>označit</Link>
            {:else if line.state === 'blocks' || line.state === 'cleaning' || line.state === 'cleaned' }
              <Link to="clean" {line} bind:issue>čistit</Link>
            {:else if line.state === 'articles' || line.state === 'checking' || line.state === 'checked' }
              <Link to="check" {line} bind:issue>kontrola</Link>
            {/if}
          </td>
          <td title="{line.journalName.split(': ')[1]}">{line.journalName.split(': ')[0]}</td>
          <td>{line.year}</td>
          <td>{line.number}</td>
          <td>{line.releaseDate}</td>
          <td>{xlate[line.state]}</td>
          <td>{line.lastChange || ''}</td>
          <td>{line.timeChanged || ''}</td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>
{/if}

<style>
  .error {
    color: red;
    margin-top: 0.5em;
  }

 

</style>
